import { CircularProgress } from "@mui/material";
import { Button } from "react-admin";

export default function CustomButtonSave({ ...props }) {
  const { onClick, label, disabled } = props;
  return (
    <Button
      label={label ? label : "Save"}
      variant="contained"
      size="medium"
      sx={{ width: "120px", ...props?.sx }}
      onClick={onClick}
      endIcon={
        label == "loading" ? (
          <CircularProgress size={16} color="inherit" />
        ) : null
      }
      disabled={disabled}
    />
  );
}
